import moment, { Moment } from 'moment'
import ShopService from '../services/shop-service';
import _ from 'lodash';
import DataStore from '../services/data-store';
import { EVENTS, base_url } from '../services/constants';
import StuartService from '../services/stuart-service';
import { CartItem, HourWithTitle, OpenHoursAtDate, Order, Shop, TreeItem } from '../../types';
import EventBus from '../services/event-bus';

EventBus.$on(EVENTS.cartChanged,()=>clearCache());

function getStringFromTimeDate(ptd): string {
    if (!ptd?.date || ptd?.date?.is_closed || ptd?.time?.is_full) {
        return null;
    } else {
        return ptd.time?.time.format('YYYY-MM-DD HH:mm:ss') || null;
    }
}
function getFirstPickupTimeDateAsync(order: Order) {
    // 3. generate pickup times
    let dates = getPickupDatesAndHours(order);
    // 2. disable full time slots
	return getFullSlotsAsync(dates, order.shop, order)
	.then(dates => {
        // 4. validate current pickup time date
        // return same datetime, or first if not found
        let keys = findTimeDateInList(dates, order);
        let dateTime = firstFreeDate(dates);
        if (keys) {
            let [d,t] = keys;
            dateTime = { date: dates[d], time: dates[d]?.hours[t] };
        }
        return dateTime;
    });
}
function firstFreeDate(dates) {
    for(let date of dates) {
        if (date.is_closed) continue;
        for(let time of date.hours) {
            if (time.is_full) continue;
            return { date: date, time: time };
        }
    }
    return null;
}
function clearCache() {
    cachedDates = null;
}

function getFirstTime(order: Order) {
    // why null ? to disable des que possible ?
    // if i end up returning firstTime, add order.deliveryZone.DeliveryDelay to PreparationDelay (if not using stuart)
    if (order.SaleAreaId == ShopService.SALE_AREAS.DELIVERY) {
        return null;
    }
    let firstTime = moment().add(order.shop.PreparationDelay, 'minutes');
    let nextHour = moment(firstTime).add(1, 'hour');
    let nextOpenMoment = ShopService.getOpeningMomentBefore(order, nextHour);
    return nextOpenMoment ? moment.max(firstTime, nextOpenMoment) : null;
}

function formatHour(hour: Moment, order: Order) {
    let str = hour.day() == moment().day() ? hour.format('HH:mm') : hour.format('dddd à HH:mm');
    if (order.SaleAreaId == ShopService.SALE_AREAS.DELIVERY) {
        str += ' - ' + moment(hour).add(order.shop.DeliveryTimeSlot || 30,'minutes').format('HH:mm');
    }
    return str;
}
// 1 - check for today and tomorraow
// 3- generate option "des que possible" for today if still open or opens in less than an hour
// 2 - display next opening date/time if no date to show
function getPickupDatesAndHours(order: Order) {
    let dates: OpenHoursAtDate[] = [];
    let PreparationDelay = order.shop.PreparationDelay
    if (StuartService.needsStuartJob(order)) {
        PreparationDelay = Math.max(60, PreparationDelay);
    } else if (order.SaleAreaId == ShopService.SALE_AREAS.DELIVERY && order.deliveryZone?.DeliveryDelay) {
        // dont add if delivery zone not defined yet
        PreparationDelay += order.deliveryZone.DeliveryDelay;
    }
    let firstTime = moment().add(PreparationDelay, 'minutes');
    let hours: Moment[];
    // 1
    if ((hours = ShopService.openHoursAfter(order, firstTime)) && hours.length) {
        let hoursWithTitle: HourWithTitle[] = _.map(hours, (hour) => ({
            title: formatHour(hour, order),
            time: hour,
        }));
        // 3
        let asap = getFirstTime(order);
        if (order.shop.info.orderAsap && asap) {
            hoursWithTitle.unshift({
                title: 'Dès que possible (' + formatHour(asap, order) + ')',
                time: asap,
            });
        }
        if (firstTime.day() == moment().day()) {
            dates.push({
                date: moment(firstTime).startOf('day').toDate(),
                title: "aujourd'hui",
                hours: hoursWithTitle,
            });
        }
    }
    for(let i = 1; i <= order.shop.PreorderDays; i++) {
        let tomorrow = moment().add(i, 'day').startOf('day');
        if ((hours = ShopService.openHoursAfter(order, moment.max(tomorrow,firstTime))) && hours.length) {
            dates.push({
                date: tomorrow.toDate(),
                title: i==1?'demain':tomorrow.format('dddd DD MMMM'),
                hours: _.map(hours, (hour) => ({
                    title: formatHour(hour, order),
                    time: hour,
                })),
            });
        } else {
            dates.push({
                date: tomorrow.toDate(),
                title: tomorrow.format('dddd DD MMMM'),
                hours: [],
                is_closed: true,
            });
        }
    }
    // 2
    if (!dates.length) {
        let nextOpenMoment = ShopService.openDateAfter(order, firstTime);
        if (nextOpenMoment) {
            dates.push({
                date: nextOpenMoment.toDate(),
                title: "Fermé jusqu'au " + nextOpenMoment.format('dddd DD MMMM'),
                hours: [],
            });
        }
    }
    return dates;
}

function findTimeDateInList(dates: OpenHoursAtDate[], order: Order): [number, number] {
    let firstTime = getFirstTime(order);
    let m = moment(order.PickupTimeDate, 'YYYY-MM-DD HH:mm:ss');
    // if (!m.isValid() || m.isBefore(firstTime)) {
    //     // m = moment(firstTime);
    //     return null;
    // }
    // now find it in dates
    let dateOnlyAsMillis = moment(m).startOf('day').unix() * 1000;
    for(let i in dates) {
        if (dates[i].date.getTime() == dateOnlyAsMillis) {
            for(let j in dates[i].hours) {
                if (m.isSame(dates[i].hours[j].time,'minute')) {
                    return [+i,+j]
                }
            }
        }
    }
    return null;
}

function isEqual(a: OpenHoursAtDate[], b: OpenHoursAtDate[]): boolean {
    if (!a || !b || a.length != b.length) {
        return false;
    }
    for(let d in a) {
        if (a[d].hours.length != b[d].hours.length) {
            return false;
        }
        for(let t in a[d].hours) {
            let t1 = a[d].hours[t]
            let t2 = b[d].hours[t]
            if (!t1.time.isSame(t2.time,'minute')) {
                return false;
            }
        }
    }
    return true;
}

let cachedSlots = null;
let cachedDates = null;
function getFullSlotsAsync(dates: OpenHoursAtDate[], shop: Shop, order: Order): Promise<OpenHoursAtDate[]> {
    let reuseSlots = false;
    if (isEqual(cachedDates, dates)) {
        reuseSlots = true;
    }
    cachedDates = dates;
    if (shop.MaxNumberCommands == -1 || shop.MaxNumberCommands == 0) {
        return Promise.resolve(dates);
    } else {
        // prepare request
        let date_indexes = [];
        for(let i in dates) {
            for(let j in dates[i].hours) {
                let m = dates[i].hours[j].time;
                date_indexes.push({
                    moment: m.format('YYYY-MM-DD HH:mm:ss'),
                    keys: [i, j],
                });
            }
        }
        let payload = {
            ShopId: shop.ShopId,
            dates: date_indexes,
        };
        let slotsPromise = Promise.resolve(cachedSlots);
        if (!reuseSlots || !cachedSlots) {
            slotsPromise = DataStore.post(base_url + '/admin/shop/number-commands-of-shop-by-date', payload,"Impossible d'obtenir la limitation des commandes")
            .then((data) => cachedSlots = data);
        }
        return slotsPromise.then((data) => {
            if (!shop.info.categoriesLimited?.length) {
                for(let i in data.dates) {
                    let numberCommands = data.dates[i].numberCommands
                    if (numberCommands >= shop.MaxNumberCommands) {
                        let [d, t] = data.dates[i].keys;
                        dates[d].hours[t].is_full = true;
                    }
                }
                return dates;
            } else {
                return fillSlotsWithCategoriesLimited(data.dates, dates, order);
            }
        })
    }
}

function fillSlotsWithCategoriesLimited(slots, dates, order): OpenHoursAtDate[] {
    let orderingProductsCount = getLimitedProductsCount(order);
    if (orderingProductsCount > 0) {
        // the only thing that interests me in slots is numberCommands,
        // so we just copy them into dates
        for(let slot of slots) {
            let [d, t] = slot.keys;
            dates[d].hours[t].numberCommands = slot.numberCommands;
        }
        // need to overflow number commands over max to previous slots
        for(let date of dates) {
            for(let t in date.hours) {
                let over = date.hours[t].numberCommands - order.shop.MaxNumberCommands;
                if (over > 0) {
                    overflowSlots(date.hours, t, order.shop.MaxNumberCommands, order.shop.DeliveryTimeSlot);
                }
            }
        }
        // mark full slots before simulating current order
        for (let date of dates) {
            for(let time of date.hours) {
                if (time.numberCommands >= order.shop.MaxNumberCommands) {
                    time.is_full = true;
                }
            }
        }
        // simulate overflow orderingProductsCount for each slot to see if we can order in that slot
        for(let date of dates) {
            for(let t in date.hours) {
                if (date.hours[t].is_full) {
                    continue;
                }
                // make a copy to simulate overflow of order in time slot
                let hoursClone = _.cloneDeep(date.hours);
                // cast string to number
                hoursClone[t].numberCommands = +hoursClone[t].numberCommands + +orderingProductsCount;
                // fill slot with current order, then try to overflow it
                if (overflowSlots(hoursClone, t, order.shop.MaxNumberCommands, order.shop.DeliveryTimeSlot)) {
                    date.hours[t].is_full = false;
                } else {
                    date.hours[t].is_full = true;
                }
            }
        }
    }
    return dates;
}

function getLimitedProductsCount(order) {
    let categories = [];
    for(let cat of order.shop.info.categoriesLimited) {
        categories.push(ShopService.getItemFromPid(cat.id, order.shop.productTree));
    }
    let count = 0;
    for(let item of order.oi) {
        // search items and its products if it is a menu
        let itemCount = 0;
        if (isItemLimited(item, categories)) {
            itemCount += item.qty;
        }
        let subItems = 0;
        for(let menuItem of item.MenuItems || []) {
            for(let menuCategoryItem of menuItem.MenuCategoryItems) {
                if (isItemLimited(menuCategoryItem, categories)) {
                    subItems += menuCategoryItem.qty;
                }
            }
        }
        let subItemsTotal = subItems * item.qty;
        // if both menu and its products are limited, return the bigger qty
        count += Math.max(itemCount, subItemsTotal);
    }
    return count;
}

function isItemLimited(item: CartItem, categories: TreeItem[]) {
    for(let cat of categories) {
        if (cat.childs.find(child => item.pId == child.id)) {
            return true;
        }
    }
    return false;
}

// returns true if it managed to overflow without hitting a full slot
function overflowSlots(hours: HourWithTitle[], i, MaxNumberCommands, DeliveryTimeSlot) {
    let numberLeftToOverflow = hours[i].numberCommands || 0;
    hours[i].numberCommands = 0;
    let current = null;
    while (numberLeftToOverflow > 0 && i >= 0) {
        if (!isContiguous(hours[i].time, current, DeliveryTimeSlot)) {
            // cannot overflow to non-contiguous time slot
            return false;
        }
        current = hours[i].time;
        let amountLeft = Math.min(numberLeftToOverflow, MaxNumberCommands - (hours[i].numberCommands || 0));
        if (amountLeft > 0) {
            hours[i].numberCommands = amountLeft;
            numberLeftToOverflow -= amountLeft;
        } else {
            // slot already full, cannot continue overflow
            return false;
        }
        i--;
    }
    // finished overflow, if nothing is left, good
    return numberLeftToOverflow <= 0;
}

function isContiguous(t1: Moment,t2: Moment, DeliveryTimeSlot) {
    if (!t2) {
        return true;
    }
    return moment(t1).add(DeliveryTimeSlot,'minutes').isSame(t2);
}

export default {
    getStringFromTimeDate,
    getFirstPickupTimeDateAsync,
    getPickupDatesAndHours,
    getFullSlotsAsync,
    findTimeDateInList,
    overflowSlots,
}